import { z } from 'zod';
import { mapSetsSchema } from './map-set.schema';

export const mapSetPagedCollectionSchema = z.object({
  size: z.number(),
  data: mapSetsSchema,
});
